import { breadcrumb } from './breadcrumb';
import { campaign } from './campaign';
import { stats } from './stats';
import { worksheets } from './worksheets';

export const autoinformer = {
  breadcrumb,
  campaign,
  stats,
  worksheets,

  task: {
    status: {
      success: 'Sukses',
      pending: 'Queue',
      processing: 'Proses',
      fail: 'Gagal'
    },

    create: 'Buat tugas',

    button: {
      create: 'Tambah task'
    },

    field: {
      number: 'Number'
    },

    table: {
      field: {
        attempts: 'Attempts',
        last_attempt: 'Last attempt'
      }
    },

    modal: {
      remove: {
        content: `Anda yakin akan melakukan penghapusan task bersama nomornya <b>{number}</b>`
      }
    }
  },
  validator: {
    field: {
      calls_limit: {
        max_value: 'Pemanggil Prediktif mendukung maks. 250 koneksi.'
      },
      date_time_error: 'Tanggal dan waktu harus lebih lambat dari saat ini dalam UTC +00:00'
    },
    empty_mediafiles: 'Periksa diagramnya. Semua elemen "File media" dan "Menu IVR" pada diagram harus berisi file audio'
  }
};
